import * as React from "react";

import { theme } from "@ovou-inc/ovou-ui";

export const OvouAiGradient = ({
  color = theme.palette.brand.primary.orange,
  width = "32",
  height = "32",
  ...restProps
}: {
  color?: string;
  width?: string;
  height?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    color={color}
    {...restProps}
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        fillRule="evenodd"
        d="M22.564 24.32c1.2-3.24 3.773-5.8 7.013-7a.773.773 0 0 0 0-1.453 11.907 11.907 0 0 1-7.013-7.013.773.773 0 0 0-1.454 0 11.901 11.901 0 0 1-5.622 6.4H5.03c-.733 0-1.333.6-1.333 1.333 0 .734.6 1.334 1.333 1.334h10.434a11.866 11.866 0 0 1 5.646 6.4c.254.68 1.2.68 1.454 0Zm-7.148-1.066h-4.88c-.733 0-1.333-.6-1.333-1.333 0-.734.6-1.334 1.334-1.334h4.88c.733 0 1.333.6 1.333 1.334 0 .733-.6 1.333-1.334 1.333Zm-8-10.667h8c.734 0 1.334-.6 1.334-1.333s-.6-1.333-1.333-1.333h-8c-.734 0-1.334.6-1.334 1.333s.6 1.333 1.334 1.333Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={3.697}
        x2={31.156}
        y1={11.55}
        y2={14.35}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DA1B7D" />
        <stop offset={1} stopColor="#FF643A" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M.75 0h32v32h-32z" />
      </clipPath>
    </defs>
  </svg>
);
